// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__2lW4l","img":"Header_img__1qQRQ","title":"Header_title__2gdFq","link":"Header_link__2Dg_U"};